<template>
  <div>
    <v-chart
      ref="chart"
      :options="chartOptions"
      theme="ovilia-green"
      style="height: 37vh!important"
      @datazoom="dataZoom"
    />
  </div>
</template>

<style>
/**
 * The default size is 600px×400px, for responsive charts
 * you may need to set percentage values as follows (also
 * don't forget to provide a size for the container).
 */
.echarts {
  width: 100%;
  height: auto;
}
</style>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/polar'
import 'echarts/lib/component/dataZoom'
import 'echarts/lib/component/markPoint'
import 'echarts/lib/component/markLine'

import theme from './theme.json'
ECharts.registerTheme('ovilia-green', theme)

export default {
  components: {
    'v-chart': ECharts,
  },
  props: {
    id: {
      type: String,
      required: true,
    },

    chartOptions: {
      type: Object,
      required: true,
    },
  },
  methods: {
    dataZoom(zoom) {
      this.$emit('dataZoom', this.id, zoom)
    },
  },
}
</script>
